require("!!D:\\TMB\\sr-git-v1\\TMB.UI\\node_modules\\script-loader\\addScript.js")(require("!!D:\\TMB\\sr-git-v1\\TMB.UI\\node_modules\\raw-loader\\index.js!D:\\TMB\\sr-git-v1\\TMB.UI\\node_modules\\source-map-loader\\index.js!D:\\TMB\\sr-git-v1\\TMB.UI\\src\\assets\\plugins\\calendar\\js\\pages.calendar.js"))


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/node_modules/script-loader!D:/TMB/sr-git-v1/TMB.UI/src/assets/plugins/calendar/js/pages.calendar.js
// module id = ../../../../script-loader/index.js!../../../../../src/assets/plugins/calendar/js/pages.calendar.js
// module chunks = scripts